<template>
  <span>
    <div @click="share">
      <slot />
    </div>

    <alert-dialog
      title="Share Link:"
      :show="showAlert"
      :centered="false"
      :actions="[{ title: 'Copy Link', callback: copy }]"
      @close="() => (showAlert = false)"
    >
      {{ copyUrl }}
    </alert-dialog>
    <input ref="urlInput" :value="copyUrl" type="text" class="copy-input" />
  </span>
</template>

<script>
import copy from "@/lib/copy"

import AlertDialog from "@/components/AlertDialog"

export default {
  components: {
    AlertDialog
  },

  props: {
    url: { type: String, default: null }
  },

  data() {
    return {
      showAlert: false,
      copyUrl: ""
    }
  },

  methods: {
    share() {
      if (window.navigator.share) {
        window.navigator
          .share({ url: this.copyUrl })
          .then(() => this.$notify("Thanks for sharing!"))
      } else {
        this.showAlert = true
      }
    },

    copy() {
      copy(this.$refs.urlInput).then(() => {
        this.showAlert = false

        this.$notify("Link Copied!")
      })
    }
  },

  mounted() {
    this.copyUrl = this.url ? this.url : window.location.href
  }
}
</script>
